import React, { useEffect, useState } from 'react';
import utils from '../../utils/utils';

const ChunkLoadError = 'ChunkLoadError';

const BugSnagFallbackError = ({ error, info }) => {
    const [latestVersion, setLatestVersion] = useState(process.env.REACT_APP_WEBAPP_VERSION);

    useEffect(() => {
        utils.handleChunkLoadingError(latestVersion, setLatestVersion, error, info);
    }, [error, info, latestVersion]);

    return <div>{error.name !== ChunkLoadError && <p>Inform users of an error in the component tree.</p>}</div>;
};

export default BugSnagFallbackError;
